/**
 * 流水默认时间窗的**中文文案唯一源** —— 依据原型 `08-家庭与设置_原型.html` 的「流水默认时间窗」行
 *
 * 依据：N 域 PRD **§5.2 ⑤**「可选 **近 1 / 3 / 6 个月**，**默认近 3 个月**；🔴 与 C 域性能铁律配套
 * （不得默认拉建账以来全部历史）。**用户级**」· **`AC-N2.18`**（必测）· `AC-N2.19`（网络审计）。
 *
 * 🔴 选项顺序 = **原型 `<select>` 的选项顺序**（近 3 → 近 1 → 近 6）——
 * 不是数值升序。契约只声明取值集，展示顺序归本文件（与 `theme-labels.ts` 同一条纪律）。
 */

import type { TxnWindowValue } from '@jiaying/shared';

/** 行标题与说明（原型 `.row-title` / `.row-desc` 原文） */
export const WINDOW_TITLE = '流水默认时间窗';
export const WINDOW_DESC = '进入流水页默认展示范围（性能铁律：不得默认拉取建账以来全部历史）';

/** 作用域说明（`DR-020` 层级铁律：用户级项必须显式标注） */
export const WINDOW_SCOPE_NOTE = '这是你自己的设置，家人不受影响；换设备登录后保持。';

/** 「默认」标注（与 `journal-labels.ts` 的 `DEFAULT_WINDOW_HINT` 同词） */
export const WINDOW_DEFAULT_HINT = '默认';

/** 保存反馈 */
export const WINDOW_SAVED_LABEL = '已保存';
export const WINDOW_SAVE_FAILED_PREFIX = '保存失败：';

export interface WindowOption {
  id: TxnWindowValue;
  label: string;
}

/** 🔴 顺序 = 原型 select 顺序（近 3 个月 / 近 1 个月 / 近 6 个月） */
export const WINDOW_OPTIONS: readonly WindowOption[] = [
  { id: '3m', label: '近 3 个月' },
  { id: '1m', label: '近 1 个月' },
  { id: '6m', label: '近 6 个月' },
];

/** 取值 → 中文（找不到时**回退原值** —— 空串会让界面出现"默认："这种半截话） */
export function windowLabelOf(value: TxnWindowValue): string {
  return WINDOW_OPTIONS.find((o) => o.id === value)?.label ?? value;
}

/**
 * 「这个偏好意味着什么」的一句说明。
 *
 * 🔴 必须把**后果**说出来：它是"进流水页先拉多长"的旋钮 —— 用户不知道这一点时，
 * 会把"选 6 个月"当成纯展示偏好，而它实际影响首屏要拉多少数据（`AC-N2.19`）。
 */
export function windowEffectNote(value: TxnWindowValue): string {
  return `进入流水页默认展示${windowLabelOf(value)}的流水；随时可在页内改成别的范围。`;
}
